// Math.abs(y-x)<24*60*60*1000

import { observable } from 'mobx'

class CostCenterState {
  currencyCode = '$'
  @observable errorMessages = {}
  @observable costCenterLastObject = {}

  validateCostCenterName = costCenterName => {
    if (costCenterName === '') {
      this.errorMessages.errorCostCenter = 'is-invalid'
      return false
    }
    return true
  }
  validateBudget = () => {
    if (
      this.costCenterLastObject.totalBudget &&
      this.costCenterLastObject.totalBudget !== this.currencyCode
    ) {
      return true
    }
    if (
      !this.costCenterLastObject.totalBudget ||
      this.costCenterLastObject.totalBudget === this.currencyCode
    ) {
      this.errorMessages.totalBudgetError = 'is-invalid'
      return false
    }
  }
  validateBudgetValue = data => {
    const onlyNumeric = /^[0-9]*$/
    const budget = data.split(this.currencyCode)
    if (budget.length > 2) {
      return false
    }
    if (budget[0] && parseInt(budget[0]) > 0) {
      if (onlyNumeric.test(budget[0])) {
        return parseInt(budget[0])
      }
    } else if (budget[1] && parseInt(budget[1]) > 0) {
      if (onlyNumeric.test(budget[1])) {
        return parseInt(budget[1])
      }
    }
    return false
  }
  handleLastField = data => {
    const totalBudget = this.validateBudgetValue(data)
    if (totalBudget) {
      this.costCenterLastObject.totalBudget = totalBudget
      this.errorMessages.totalBudgetError = ''
    } else {
      this.errorMessages.totalBudgetError = 'is-invalid'
    }
  }
  checkForSameDate = (selectedDate, existingDate) => {
    const { startDate, endDate } = selectedDate
    const existingEndDate = existingDate.endDate
    const existingStartDate = existingDate.startDate
    if (existingStartDate >= startDate && existingEndDate <= endDate) {
      this.errorMessages.errorEndDate = 'is-invalid'
      this.errorMessages.errorStartDate = 'is-invalid'
      return true
    } else if (startDate < existingEndDate) {
      this.errorMessages.errorStartDate = 'is-invalid'
      return true
    } else if (endDate < existingStartDate) {
      this.errorMessages.errorEndDate = 'is-invalid'
      return true
    }
    this.errorMessages.errorEndDate = ''
    this.errorMessages.errorStartDate = ''
    return false
  }
  checkSelectedDate = costCenterArray => {
    const isEndDateGreaterThanStartDate =
      this.costCenterLastObject.startDate > this.costCenterLastObject.endDate

    /** @note sonarqube throws following error
     * Boolean expressions should not be gratuitous
     * make sure the variable is an object
     **/
    const endDateGreaterThanStartDate = {
      dateObj: isEndDateGreaterThanStartDate,
    }

    if (isEndDateGreaterThanStartDate) {
      this.errorMessages.errorEndDate = 'is-invalid'
      return false
    }
    const isInvalidDate =
      costCenterArray &&
      costCenterArray.find(array => {
        return this.checkForSameDate(this.costCenterLastObject, array)
      })

    if (!isInvalidDate && endDateGreaterThanStartDate.dateObj === false) {
      return true
    }
    return false
  }
  validateBudgetDate = costCenterArray => {
    const isStartDateInvalid =
      !this.costCenterLastObject.startDate ||
      this.costCenterLastObject.startDate === ''
    const isEndDateInValid =
      !this.costCenterLastObject.endDate ||
      this.costCenterLastObject.endDate === ''
    if (isStartDateInvalid) {
      this.errorMessages.errorStartDate = 'is-invalid'
    }
    if (isEndDateInValid) {
      this.errorMessages.errorEndDate = 'is-invalid'
    }
    if (isEndDateInValid || isStartDateInvalid) {
      return false
    }
    return this.checkSelectedDate(costCenterArray)
  }
  handleChangeDate = (date, props) => {
    if (props.isStartDate) {
      const startDateTimeStamp = date ? date.getTime() : ''
      this.costCenterLastObject.startDate = startDateTimeStamp
      this.errorMessages.errorStartDate = ''
    } else {
      /* @note
       * cost center end-date time should be 23:59:59
       * so, changed the endtime from 12:00am to 23:59pm format
       */
      const endDateTimeStamp = date ? date.setHours(23, 59, 59, 999) : ''
      this.costCenterLastObject.endDate = endDateTimeStamp
      this.errorMessages.errorEndDate = ''
    }
  }
}

export { CostCenterState }
